export default function parseJwt(token) {
    // Check if token exists and is valid
    if (!token || typeof token !== 'string' || token.trim() === '') {
        console.warn('⚠️ parseJwt: Invalid or missing token');
        return null;
    }
    
    try {
        var base64Url = token.split('.')[1];
        if (!base64Url) {
            console.warn('⚠️ parseJwt: Invalid JWT format');
            return null;
        }
        var base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    } catch (error) {
        console.error('❌ parseJwt error:', error);
        return null;
    }
}